// nodo.utils.ts
import { Nodo } from './nodo.model';

export function parseNodos(json: string): Nodo[] {
  const data = JSON.parse(json);

  if (!Array.isArray(data)) {
    throw new Error('El JSON no es un arreglo');
  }

  return data.map(mapNodo);
}

export function mapNodo(obj: any): Nodo {
  return {
    Id: obj.Id,
    IdBd: obj.IdBd,
    Nombre: obj.Nombre,
    Correo: obj.Correo,
    ParentId: obj.ParentId ?? null,
    bCorreoEnviado: obj.bCorreoEnviado,
    passAux: obj.passAux,
    saltAux: obj.saltAux,
    Hijos: Array.isArray(obj.Hijos)
      ? obj.Hijos.map(mapNodo)
      : []
  };
}
